module.exports = __webpack_public_path__ + "img/Group4.8dd2a126.svg";